import { render, staticRenderFns } from "./settle.vue?vue&type=template&id=37d863bb&scoped=true&"
import script from "./settle.vue?vue&type=script&lang=js&"
export * from "./settle.vue?vue&type=script&lang=js&"
import style0 from "./settle.vue?vue&type=style&index=0&id=37d863bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d863bb",
  null
  
)

export default component.exports